module.exports = __webpack_public_path__ + "img/square-chevron-up.850a09b1.svg";